<ng-container *ngIf="licenceBandGroupData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="licenceBandGroupData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--withSwitch">
    <h2 class="Bands">Group of bands</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/' [queryParams]="{regionCode: regionCodes}">Licences</a> {{ ('GroupOfBandsTitles.' + licenceBandGroupData.bandGroup) | translate }}</h1>
    <div class="Switch" (click)="toggleActiveMode()" [ngClass]="graphicMode ? 'Active' : ''">
        <label for="on">
            <span data-title="Graphic"></span>
        </label>
    </div>
  </div>
  <div *ngIf="isTableMode()" class="TableMode" [class.Active]="isTableMode()">
    <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile" *ngIf="licenceBandGroupData.licences.length > 0">
      <thead>
        <tr>
          <th scope="col">Country</th>
          <th scope="col">Operator</th>
          <th scope="col">MHz</th>
          <th scope="col">Bands</th>
          <th scope="col">Awards</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of licenceBandGroupData.licences">
          <td data-th="Country" class="NoWrap">
            <a [routerLink]="'/licences/country/'+row.countryCode" [queryParams]="{regionCode: regionCodes}">{{ ('CountryNames.' + row.countryCode) | translate }}</a>
          </td>
          <td data-th="Operator – MHz" class="NoWrap" [class.EmptyCell]="row.operatorBandwidths.length===0">
            <div *ngFor="let operatorBandwidth of row.operatorBandwidths" class="Loop">{{ operatorBandwidth.operator }} <span class="ShowOnlyOnMobile">– {{ operatorBandwidth.bandwidth }}</span></div>
          </td>
          <td data-th="MHz" class="NoWrap HideCellOnMobile" [class.EmptyCell]="row.operatorBandwidths.length===0">
            <div *ngFor="let operatorBandwidth of row.operatorBandwidths" class="Loop">{{ operatorBandwidth.bandwidth }}</div>
          </td>
          <td data-th="Bands" [class.EmptyCell]="row.bands.length===0">
            <span *ngFor="let band of row.bands; last as isLast;">
              <span style="display: inline-block;"><a [routerLink]="'/licences/country/'+row.countryCode+'/band/'+band.code" [queryParams]="{regionCode: regionCodes}">{{ band.name }}</a><span *ngIf="!isLast">,&nbsp;</span></span>
            </span>
          </td>
          <td data-th="Awards" [class.EmptyCell]="row.awards.length===0">
            <span *ngFor="let award of row.awards; last as isLast;">
              <span style="display: inline-block;"><a [routerLink]="'/awards/'+award.awardKey" [queryParams]="{regionCode: regionCodes}">{{ award.awardKey | delete2FirstChar }}</a><span *ngIf="!isLast">,&nbsp;</span></span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="NoResult" *ngIf="licenceBandGroupData.licences.length===0 && !licenceBandGroupData.light">
      <p>No licence registered in the database</p>
    </div>
    <div class="NoResult" *ngIf="licenceBandGroupData.licences.length===0 && licenceBandGroupData.light">
      <p>No licence registered in the database or Upgrade your subscription</p>
    </div>
  </div>
  <div *ngIf="isGraphicMode()" class="GraphicMode" [class.Active]="isGraphicMode()">
    <div class="GraphicMode-header" *ngIf="licenceBandGroupData.licences.length > 0">
      <div class="GraphicMode-country">
        <h3>Country</h3>
      </div>
      <div class="GraphicMode-content">
        <div class="GraphicMode-Bands">
          <div *ngFor="let band of licenceBandGroupData.allBands" class="GraphicMode-Band">
            <h3><a [routerLink]="'/licences/band/'+band.code" [queryParams]="{regionCode: regionCodes}">{{ ('Band.' + band.code) | translate }}</a></h3>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let row of licenceBandGroupData.licences;" class="GraphicMode-row">
      <div class="GraphicMode-country" [class.GraphicMode-country--active]="isActiveRow(row)" (click)="toggleActiveRows(row)">
        <h2><a [routerLink]="'/licences/country/'+row.countryCode">{{ ('CountryNames.' + row.countryCode) | translate }}</a></h2>
      </div>
      <div class="GraphicMode-content">
        <div class="GraphicMode-Bands">
          <div *ngFor="let band of licenceBandGroupData.allBands" class="GraphicMode-Band" [class.GraphicMode-Band--empty]="">
            <ng-container *ngIf="getBandIfExist(band.code, row.bands) as bandObject">
              <ng-template #tipContent>{{bandObject.ratio}}% awarded</ng-template>
              <a [routerLink]="'/licences/country/'+row.countryCode+'/band/'+band.code" [queryParams]="{regionCode: regionCodes}" class="Band Band--{{band.code}}" [ngbTooltip]="tipContent" [class.Band--empty]="bandObject.ratio === 0">
                <div class="Band-container">
                  <p>{{ ('Band.' + band.code) | translate }}</p>
                  <span class="Progress" [style.width]="bandObject.ratio+'%'"></span>
                </div>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="NoResult" *ngIf="licenceBandGroupData.licences.length===0">
      <p>No licence</p>
    </div>
  </div>
</ng-container>
